import React from 'react';
import { 
  ChevronRight, 
  Users, 
  MessageSquare, 
  Lightbulb, 
  Share2,
  BookOpen,
  HandHeart
} from 'lucide-react';

const CommunityPage = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900">
      <div className="relative pt-16 pb-20 sm:pt-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">Coming soon... </h1>
            \n
            <h1 className="text-4xl font-bold mb-6 text-white">
              <span className="block">Connect with the</span>
              <span className="block text-blue-400">Quantum Community</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
             Whether you're a quantum physicist, software developer, or industry professional, our platform connects you with opportunities, mentors, and collaborators shaping the quantum computing ecosystem.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <button className="rounded-md bg-blue-500 px-6 py-3 text-white hover:bg-blue-600 flex items-center justify-center">
                Join Community
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
              <button className="rounded-md border border-white px-6 py-3 text-white hover:bg-white/10 flex items-center justify-center">
                Browse Discussions
                <MessageSquare className="ml-2 h-4 w-4" />
              </button>
            </div>

            {/* Community Highlights */}
            {/*
            <div className="mt-12 bg-white/10 rounded-lg p-6 max-w-3xl mx-auto backdrop-blur-sm">
              <h2 className="text-2xl font-semibold text-white mb-3">Community Highlights</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">5,000+</div>
                  <div className="text-gray-300">Active Members</div>
                </div>
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">100+</div>
                  <div className="text-gray-300">Monthly Discussions</div>
                </div>
              </div>
            </div> */}

            {/* Community Features */}
            <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div className="flex flex-col items-center">
                <Share2 className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Knowledge Sharing</h3>
                <p className="mt-2 text-gray-300">Exchange ideas and insights with peers</p>
              </div>
              <div className="flex flex-col items-center">
                <HandHeart className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Mentorship</h3>
                <p className="mt-2 text-gray-300">Connect with industry experts</p>
              </div>
              <div className="flex flex-col items-center">
                <BookOpen className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Learning Resources</h3>
                <p className="mt-2 text-gray-300">Access community-curated content</p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Users className="h-4 w-4" />
                <span>Study Groups</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <MessageSquare className="h-4 w-4" />
                <span>Forums</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Lightbulb className="h-4 w-4" />
                <span>Projects</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <HandHeart className="h-4 w-4" />
                <span>Mentorship</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage;